<script lang="ts" setup>
import { getMetaTags } from '~/utils/meta'

definePageMeta({
  layout: false
})

const { baseKey } = useI18n('pages.login')

useSeoMeta(
  getMetaTags(
    {
      title: '.meta.title',
      description: '.meta.description'
    },
    undefined,
    baseKey
  )
)

const route = useRoute()

const onLogin = () => {
  const redirect = route.query.redirect as string

  if (redirect) {
    navigateTo({
      path: redirect
    })
  } else {
    navigateTo({ name: 'account' })
  }
}
</script>

<template>
  <div>
    <NuxtLayout name="no-hero" hide-footer>
      <RandomBackgroundImages :max-icons="4" is-set-amount />

      <section class="section flex max-w-prose flex-col items-center justify-center">
        <LoginComponent @login="onLogin" />
      </section>
    </NuxtLayout>
  </div>
</template>

<style scoped></style>
